<template>
    <div class="about">
        <v-container class="mt-5 mb-5">
            <v-row class="about-content mt-5 mb-5">
                <v-col cols="8" style="margin-top: 50px">
                    <div class="text-about">
                        <h3 class="mb-5">{{oracle.translate('فروشگاه کلانا')}}</h3>
                        <span>
                          {{oracle.translate(aboutText)}}
                        </span>
                    </div>
                </v-col>
                <v-col cols="4">
                    <div class="img-about">
                        <img alt="" src="../assets/image/about.png" />
                    </div>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>
<script>
    import oracle from "../oracle";

    export default {
        name: "about",
      computed: {
        oracle() {
          return oracle
        },
        aboutText() {
          return "پیشنهاد ارائه میان وعده هایی کامل از ساعات اولیه روز که از نیازهای اساسی شهرهای بزرگ، به علت کمبود وقت و سرعت بالای زندگی شهری است، ایده بنیانگذاری فروشگاه های کلانا را در سال ۱۳۸۹ برای برطرف کردن این نیاز مهم جامعه در ذهن ما خلق کرد. همکاران ما از ساعت ۷:۳۰ صبح با سخت کوشی خود و کار گروهی، محصولات کلانا را به صورت روزانه و با استفاده از تازه ترین مواد اولیه (که در خانه مصرف می کنیم) تهیه می کنند. آن ها دوستدار متمایز کردن محصولات کلانا با بهره‌گیری از خلاقیت های منحصر به فرد خود هستند. تازگی و سلامت محصولات کلانا در کنار مزه هایی متفاوت و تنوعی محسوس شامل اسنک، کلاب، رپ، کوکی، مافین، دسر، سالاد، نوشیدنی سرد و گرم و ... مکمل خوبی برای ارائه این فعالیت جدید است که امیدواریم از طرف شما به عنوان یک سرویس خوب و قابل اطمینان تجربه شود."
        }
      },
    };
</script>
<style>
    .about .img-about {
        width: 100%;
        height: 300px;
    }

    .about .img-about img {
        width: 100%;
        height: 100%;
        object-fit: contain;
    }

    .about .text-about span {
        font-size: 14px;
        margin-top: 100px;
        line-height: 30px;
        color: #333;
    }

    .about {
        display: flex;
        background: #fff;
    }

    .about .about-content {
        display: flex;
        flex-direction: row-reverse;
    }

    @media only screen and (max-width: 480px) {
        .about .about-content {
            display: flex;
            flex-direction: column;
            justify-content: center !important;
        }

        .about .img-about {
            width: 400px;
            height: 100px;
        }

        .about .text-about span {
            font-size: 12px;
            line-height: 30px;
            padding-top: 10px;
        }

        .about .text-about {
            display: flex;
        }
    }
</style>
